import {Article} from "./article";
import {PricingItem} from "./pricing-item";
import {parseBig} from "../../../../utils/math-utils";

export class ConsumablePricingItem extends PricingItem {
    public consumable?: Article;
    public consumableExtraPrice?: string;
    public hasFranchiseConso?: () => boolean = (): boolean => {
        return parseBig(this.userInputs?.franchiseConso).gt(0);
    };
}
